import React from 'react';
import { Link } from 'react-router-dom';
import CostcoLogo from './CostcoLogo';

function CostcoNav({ user, menuRef, isMenuOpen, setIsMenuOpen, onLogout }) {
	return (
		<nav className="costco-nav">
			<div className="costco-nav__left" ref={menuRef}>
				<button
					type="button"
					className={`costco-nav__menu ${isMenuOpen ? 'costco-nav__menu--open' : ''}`}
					onClick={(e) => {
						e.stopPropagation();
						setIsMenuOpen(!isMenuOpen);
					}}
					aria-label="Toggle menu"
				>
					<span />
					<span />
					<span />
				</button>
				<div className={`costco-nav__links ${isMenuOpen ? 'costco-nav__links--open' : ''}`}>
					<Link to="/" onClick={() => setIsMenuOpen(false)}>
						Map
					</Link>
					<Link to="/account" onClick={() => setIsMenuOpen(false)}>
						Account
					</Link>
					<Link to="/privacy-policy" onClick={() => setIsMenuOpen(false)}>
						Privacy
					</Link>
					<Link to="/terms-of-service" onClick={() => setIsMenuOpen(false)}>
						Terms
					</Link>
				</div>
			</div>
			<div className="costco-nav__center">
				<Link to="/" className="costco-nav__logo" aria-label="CostcoChase home">
					<CostcoLogo />
				</Link>
			</div>
			<div className="costco-nav__right">
				{user ? (
					<>
						<span className="costco-nav__welcome">Hi, {user.name || user.email?.split('@')[0]}</span>
						<button type="button" className="costco-nav__signout" onClick={onLogout}>
							Sign out
						</button>
					</>
				) : (
					<Link to="/login" className="costco-nav__signin">
						Sign in
					</Link>
				)}
			</div>
		</nav>
	);
}

export default CostcoNav;
